var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee9321;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34,40H6a4,4,0,0,1-4-4L2,8A4,4,0,0,1,6,4H8V2a2,2,0,0,1,4,0V4H28V2a2,2,0,0,1,4,0V4h2a4,4,0,0,1,4,4V36A4,4,0,0,1,34,40ZM6,14H6V34a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V14Zm24,8H26V18h4Zm-8,0H18V18h4Zm-8,0H10V18h4Z",
    transform: "translate(-2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconPrimary);
export default __webpack_public_path__ + "static/media/calendar_icon_primary.1dc89395dc1bac6b88dec30022d0015b.svg";
export { ForwardRef as ReactComponent };